import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';

export interface AppState {
  isDummyMode: boolean
  isMaintenance: boolean
  isShowMoreMsg: boolean
  errCode: string
}

@Module({
  name: 'app',
  namespaced: true,
  dynamic: true,
  store,
})
export default class App extends VuexModule {
  public isDummyMode: boolean = false;
  public isMaintenance: boolean = false;
  public isShowMoreMsg: boolean = false;
  public errCode: string = '';

  @Mutation
  public setIsDummyMode(isDummyMode: boolean) {
    this.isDummyMode = isDummyMode
  }

  @Mutation
  public setIsMaintenance(isMaintenance: boolean) {
    this.isMaintenance = isMaintenance
  }

  @Mutation
  public setIsShowMoreMsg(isShowMoreMsg: boolean) {
    this.isShowMoreMsg = isShowMoreMsg
  }

  @Mutation
  public setErrCode(errCode: string) {
    this.errCode = errCode
  }

  @Action
  public clearErrCode() {
    this.setErrCode('')
  }
}

export const AppModule = getModule(App)
